export const types = {
    login : '[AUTH] Login',
    logout : '[AUTH] Logout'
}
